import React, { Component } from 'react';
import about from './../about.js';

class About extends Component {
	componentWillMount() {
		about.setPageActive(true);
	}

	componentWillUnmount() {
		about.setPageActive(false);
	}

	render() {
		return (
			<div id="about" />
		);
	}
}

export default About;



// WEBPACK FOOTER //
// ./mobile-core/src/components/about.js